import React, { useEffect } from 'react';

import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';
import useStateRef from 'react-usestateref';
import { useTranslation } from 'react-i18next';

export function DarkButton(props: {
	text: string | null;
	onClick?: any;
	override?: boolean;
	filled?: boolean;
	className?: string;
	hideArrow?: boolean;
	style?: any;
	childDivStyle?: any;
	disabled?: boolean;
	loader?: boolean;
	invalidInputs?: boolean;
	errorfields?: any[];
	hidden?: boolean;
	validationError?: string;
	//loadCondition?: boolean;
}) {
	const { t } = useTranslation();
	const [_, setButtonLoading, buttonLoadingRef] = useStateRef(false);

	useEffect(() => {
		if (props.override) {
			setButtonLoading(false);
		}
	}, [props.override]);

	useEffect(() => {
		if (props.invalidInputs) {
			const errorMessage =
				props.errorfields && props.errorfields.length > 0
					? `Please ensure ${props.errorfields.join(
							','
					  )}  are correct for successful check-in.`
					: null;

			Swal.fire({
				title: 'Invalid contact details',
				text: errorMessage ?? '',
				icon: 'error',
			}).then(function () {
				console.log('invalid inputs');
				setButtonLoading(false);
			});
		}
	}, [props.invalidInputs]);

	const handleClick = () => {
		setButtonLoading(true);
		props.onClick && props.onClick();
	};

	return (
		<>
			{props.onClick ? (
				<button
					type="button"
					onClick={handleClick}
					className={`col-lg-12 rounded-pill px-2 py-3 ${
						props.className ?? ''
					}`}
					disabled={props.disabled}
					hidden={props.hidden}
					style={{
						background: buttonLoadingRef.current
							? '#cccccc'
							: props.filled
							? '#03355C'
							: 'white',
						color: buttonLoadingRef.current
							? '#666666'
							: props.filled
							? 'white'
							: '#03355C',
						borderColor: buttonLoadingRef.current
							? 'black'
							: props.filled
							? 'white'
							: '#03355C',
						padding: '16px 32px 16px 32px',
						marginTop: '20px',
						width: '100%',
						fontWeight: 500,
						maxWidth: '400px',
						borderStyle: 'solid',
						...props.style,
						opacity: props.disabled ? 0.5 : 1,
						cursor: props.disabled ? 'not-allowed' : 'pointer',
					}}>
					<div
						className="d-flex flex-row align-items-center justify-content-center"
						style={{
							...props.childDivStyle,
							fontSize: '1.125rem',
						}}>
						{buttonLoadingRef.current === true ? (
							<>
								<span
									className="spinner-grow spinner-grow-sm"
									role="status"
									style={{ marginRight: '20px' }}
								/>
								{t('AllPagesLoading')}
							</>
						) : (
							<>
								<span className="flex-grow-1">{props.text}</span>
								{!props.hideArrow && <FontAwesomeIcon icon={faChevronRight} />}
							</>
						)}
					</div>
				</button>
			) : (
				''
			)}
		</>
	);
}
